(function () {
  // Accessible product tabs (WCAG 2.1.1, 4.1.2): buttons with role="tab", a roving tabindex,
  // Left/Right/Home/End keys, and panels that are hidden when inactive. The li.active classes keep the look.
  function initProductTabs(root) {
    if (root.cqProductTabsCleanup) return;
    var tabLinks = Array.prototype.slice.call(root.querySelectorAll('.pdp-tab-part .tablinks'));
    var tabContent = root.querySelectorAll('.pdp-tab-part .tabcontent');
    var removeListeners = [];

    if (!tabLinks.length) return;

    // Move the original description nodes, never a second HTML copy. Product-body IDs, media and
    // any attached interactions stay the same when desktop tabs become mobile accordions.
    var isDesktop = window.matchMedia('(min-width: 990px)');
    var descriptionSlots = Array.prototype.map.call(root.querySelectorAll('[data-cq-description-desktop]'), function (desktop) {
      var mobile = root.querySelector('[data-cq-description-mobile="' + desktop.dataset.cqDescriptionDesktop + '"]');
      return { desktop: desktop, mobile: mobile };
    }).filter(function (pair) { return pair.mobile; });

    function placeDescriptions() {
      descriptionSlots.forEach(function (pair) {
        var source = isDesktop.matches ? pair.mobile : pair.desktop;
        var target = isDesktop.matches ? pair.desktop : pair.mobile;
        while (source.firstChild) target.appendChild(source.firstChild);
      });
    }

    function listen(element, type, listener) {
      element.addEventListener(type, listener);
      removeListeners.push(function () { element.removeEventListener(type, listener); });
    }

    function activate(link, moveFocus) {
      var target = Array.prototype.find.call(tabContent, function (content) { return content.id === link.dataset.tab; });
      if (!target) return;

      tabContent.forEach(function (content) {
        var on = content === target;
        content.classList.toggle('active', on);
        content.hidden = !on;
      });

      tabLinks.forEach(function (el) {
        var on = el === link;
        el.parentNode.classList.toggle('active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        el.setAttribute('tabindex', on ? '0' : '-1');
      });

      if (moveFocus) link.focus();
    }

    tabLinks.forEach(function (link, index) {
      listen(link, 'click', function (event) {
        event.preventDefault();
        activate(event.currentTarget, false);
      });

      listen(link, 'keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = tabLinks[(index + 1) % tabLinks.length];
        else if (event.key === 'ArrowLeft') next = tabLinks[(index - 1 + tabLinks.length) % tabLinks.length];
        else if (event.key === 'Home') next = tabLinks[0];
        else if (event.key === 'End') next = tabLinks[tabLinks.length - 1];
        if (!next) return;
        event.preventDefault();
        activate(next, true);
      });
    });

    placeDescriptions();
    if (isDesktop.addEventListener) {
      listen(isDesktop, 'change', placeDescriptions);
    } else if (isDesktop.addListener) {
      isDesktop.addListener(placeDescriptions);
      removeListeners.push(function () { isDesktop.removeListener(placeDescriptions); });
    }
    root.cqProductTabsCleanup = function () {
      removeListeners.forEach(function (remove) { remove(); });
      descriptionSlots.forEach(function (pair) {
        while (pair.mobile.firstChild) pair.desktop.appendChild(pair.mobile.firstChild);
      });
      delete root.cqProductTabsCleanup;
    };
  }

  function init(scope) {
    scope.querySelectorAll('.cq-pdp-full-description').forEach(initProductTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.cq-pdp-full-description').forEach(function (root) {
      if (root.cqProductTabsCleanup) root.cqProductTabsCleanup();
    });
  });
})();
